import MyLink from '@/components/zthd/my-link'
import { formatPercent, formatUSD } from '@/lib/format-utils'

const Td3 = ({ event, freeTry, dnu }) => {
  const eventValue = event?.value
  const freeTryValue = freeTry
  const rate = formatPercent(eventValue / freeTryValue, 2, 2)
  const avg = formatPercent(eventValue / dnu, 2, 2)
  if (!eventValue) return null
  return (
    <div className="flex flex-col text-right">
      <div>{eventValue}</div>
      <div className="text-xs text-muted-foreground">{rate}</div>
      <div className="text-xs text-muted-foreground">{avg}</div>
    </div>
  )
}

const GroupHeader = ({ children }) => {
  return (
    <div className="">
      {children}
      <span className="text-xs ms-1 text-muted-foreground">来自于</span>
    </div>
  )
}

export const eventAtColumn = {
  id: 'eventAt',
  header: 'Event At',
  accessorFn: (row) => row.eventAt,
  cell: (row) => {
    const eventAt = row.getValue()
    return <MyLink to={`/apple/events1/${eventAt}/roadmap`}>{eventAt}</MyLink>
  },
}

export const subAtColumn = {
  id: 'subAt',
  header: 'Sub At',
  accessorFn: (row) => row.subAt,
  cell: (row) => {
    const subAt = row.getValue()
    return <MyLink to={`/apple/events2/${subAt}/roadmap`}>{subAt}</MyLink>
  },
}

export const dnuColumn = {
  id: 'dnu',
  header: 'DNU',
  accessorFn: (row) => row.dnu,
  cell: (row) => {
    const dnu = row.getValue()
    return <div>{dnu}</div>
  },
}

export const eventColumn = (event) => ({
  id: event.id,
  header: event.name,
  accessorFn: (row) => {
    const e = row.events?.find((e) => e.event === event.id)
    const freeTry = row.freeTry
    const dnu = row.dnu
    return { event: e, freeTry, dnu }
  },
  cell: (row) => {
    const { event, freeTry, dnu } = row.getValue()
    return <Td3 event={event} freeTry={freeTry} dnu={dnu}></Td3>
  },
})

export const paidColumn = {
  id: 'paid',
  header: () => <GroupHeader>正式付费+</GroupHeader>,
  columns: [
    ...[
      {
        id: 'Paid Subscription from Introductory Offer',
        name: '试用结束',
      },
      {
        id: 'Crossgrade from Introductory Offer',
        name: '推介跨档',
      },
      { id: 'Renewal from Billing Retry', name: '账单重试' },
    ].map((e) => eventColumn(e)),
  ],
}

export const renewColumn = {
  id: 'renew',
  header: () => <GroupHeader>续订+</GroupHeader>,
  columns: [
    ...[
      { id: 'Renew', name: '续订' },
      // { id: 'Renewals from Grace Period', name: '宽限期' },
    ].map((e) => eventColumn(e)),
  ],
}

export const cancelColumn = {
  id: 'cancel',
  header: () => <GroupHeader>取消</GroupHeader>,
  columns: [
    ...[
      { id: 'Cancel', name: '直接取消' },
      // { id: 'Canceled from Billing Retry', name: '账单重试' },
    ].map((e) => eventColumn(e)),
  ],
}

export const freeTryColumn = eventColumn({
  id: 'Start Introductory Offer',
  name: '试用期',
})

export const refundColumn = {
  id: 'refundGroup',
  header: '退款-',
  columns: [eventColumn({ id: 'Refund', name: '' })],
}

export const billRetryColumn = {
  id: 'billRetry',
  header: () => <GroupHeader>账单重试</GroupHeader>,
  columns: [
    ...[
      // { id: 'Billing Retry from Introductory Offer', name: '试用期' },
      // { id: 'Billing Retry from Paid Subscription', name: '正式付费' },
      // { id: 'Billing Retry from Grace Period', name: '宽限期' },
    ].map((e) => eventColumn(e)),
  ],
}

export const reactivateColumn = {
  id: 'reactivate',
  header: () => <GroupHeader>重新激活</GroupHeader>,
  columns: [
    ...[
      // { id: 'Reactivate', name: '重新激活' },
      // { id: 'Reactivate with Crossgrade', name: '跨级升级' },
    ].map((e) => eventColumn(e)),
  ],
}

export const gracePeriodColumn = {
  id: 'gracePeriod',
  header: () => <GroupHeader>进入宽限期</GroupHeader>,
  columns: [
    ...[
      // { id: 'Grace Period from Paid Subscription', name: '正式付费' },
      // {
      //   id: 'Grace Period from Introductory Offer',
      //   name: '试用期',
      // },
    ].map((e) => eventColumn(e)),
  ],
}

// ---- for subscribe summary ----

export const subDateColumn = {
  id: 'eventAt',
  header: 'Event At',
  accessorFn: (row) => row.eventAt,
  cell: (row) => {
    const eventAt = row.getValue()
    // return <MyLink to={`/apple/events1/${eventAt}/roadmap`}>{eventAt}</MyLink>
    return <div>{eventAt}</div>
  },
  meta: {
    sticky: true,
    stickyLeft: 'left-[0px]',
  },
}

export const totalColumn = {
  id: 'total',
  header: 'Total',
  accessorFn: (row) => row.total,
  cell: (row) => {
    const total = row.getValue()
    return (
      <div className="flex flex-col text-right">
        <div>{total.userCount}</div>
        <div className="text-xs text-muted-foreground">{formatUSD(total.revenue)}</div>
      </div>
    )
  },
}

export const trialStartColumn = {
  id: 'af_ars_trial_started',
  header: '开始试用',
  accessorFn: (row) => row.af_ars_trial_started,
  cell: (row) => {
    const trialStart = row.getValue()
    return (
      <div className="flex flex-col text-right">
        <div>{trialStart?.userCount}</div>
        <div className="text-xs text-muted-foreground">{formatUSD(trialStart?.revenue)}</div>
      </div>
    )
  },
}

export const trialCanceledColumn = {
  id: 'af_ars_trial_canceled',
  header: '取消试用',
  accessorFn: (row) => row.af_ars_trial_canceled,
  cell: (row) => {
    const trialCanceled = row.getValue()
    return (
      <div className="flex flex-col text-right">
        <div>{trialCanceled?.userCount}</div>
        <div className="text-xs text-muted-foreground">{formatUSD(trialCanceled?.revenue)}</div>
      </div>
    )
  },
}

export const trialChurnedColumn = {
  id: 'af_ars_trial_churned',
  header: '试用后流失',
  accessorFn: (row) => row.af_ars_trial_churned,
  cell: (row) => {
    const trialChurned = row.getValue()
    return (
      <div className="flex flex-col text-right">
        <div>{trialChurned?.userCount}</div>
        <div className="text-xs text-muted-foreground">{formatUSD(trialChurned?.revenue)}</div>
      </div>
    )
  },
}

export const trialConvertedColumn = {
  id: 'af_ars_trial_converted',
  header: '试用后转化',
  accessorFn: (row) => row.af_ars_trial_converted,
  cell: (row) => {
    const trialConverted = row.getValue()
    return (
      <div className="flex flex-col text-right">
        <div>{trialConverted?.userCount}</div>
        <div className="text-xs text-muted-foreground">{formatUSD(trialConverted?.revenue)}</div>
      </div>
    )
  },
}

export const subscriptionStartedColumn = {
  id: 'af_ars_subscription_started',
  header: '套餐生效',
  accessorFn: (row) => row.af_ars_subscription_started,
  cell: (row) => {
    const subscriptionStarted = row.getValue()
    return (
      <div className="flex flex-col text-right">
        <div>{subscriptionStarted?.userCount}</div>
        <div className="text-xs text-muted-foreground">{formatUSD(subscriptionStarted?.revenue)}</div>
      </div>
    )
  },
}

export const subscriptionResumedColumn = {
  id: 'af_ars_subscription_resumed',
  header: '订阅已恢复',
  accessorFn: (row) => row.af_ars_subscription_resumed,
  cell: (row) => {
    const subscriptionResumed = row.getValue()
    return (
      <div className="flex flex-col text-right">
        <div>{subscriptionResumed?.userCount}</div>
        <div className="text-xs text-muted-foreground">{formatUSD(subscriptionResumed?.revenue)}</div>
      </div>
    )
  },
}

export const subscriptionChurnedColumn = {
  id: 'af_ars_subscription_churned',
  header: '订阅用户流失',
  accessorFn: (row) => row.af_ars_subscription_churned,
  cell: (row) => {
    const subscriptionChurned = row.getValue()
    return (
      <div className="flex flex-col text-right">
        <div>{subscriptionChurned?.userCount}</div>
        <div className="text-xs text-muted-foreground">{formatUSD(subscriptionChurned?.revenue)}</div>
      </div>
    )
  },
}

export const subscriptionCanceledColumn = {
  id: 'af_ars_subscription_canceled',
  header: '订阅已取消',
  accessorFn: (row) => row.af_ars_subscription_canceled,
  cell: (row) => {
    const subscriptionCanceled = row.getValue()
    return (
      <div className="flex flex-col text-right">
        <div>{subscriptionCanceled?.userCount}</div>
        <div className="text-xs text-muted-foreground">{formatUSD(subscriptionCanceled?.revenue)}</div>
      </div>
    )
  },
}

export const subscriptionPausedColumn = {
  id: 'af_ars_subscription_paused',
  header: '订阅已暂停(Android)',
  accessorFn: (row) => row.af_ars_subscription_paused,
  cell: (row) => {
    const subscriptionPaused = row.getValue()
    return (
      <div className="flex flex-col text-right">
        <div>{subscriptionPaused?.userCount}</div>
        <div className="text-xs text-muted-foreground">{formatUSD(subscriptionPaused?.revenue)}</div>
      </div>
    )
  },
}

export const subscriptionRefundedColumn = {
  id: 'af_ars_subscription_refunded',
  header: '订阅已退款',
  accessorFn: (row) => row.af_ars_subscription_refunded,
  cell: (row) => {
    const subscriptionRefunded = row.getValue()
    return (
      <div className="flex flex-col text-right">
        <div>{subscriptionRefunded?.userCount}</div>
        <div className="text-xs text-muted-foreground">{formatUSD(subscriptionRefunded?.revenue)}</div>
      </div>
    )
  },
}

export const subscriptionBillingGraceColumn = {
  id: 'af_ars_subscription_billing_grace',
  header: '订阅计费宽限期',
  accessorFn: (row) => row.af_ars_subscription_billing_grace,
  cell: (row) => {
    const subscriptionBillingGrace = row.getValue()
    return (
      <div className="flex flex-col text-right">
        <div>{subscriptionBillingGrace?.userCount}</div>
        <div className="text-xs text-muted-foreground">{formatUSD(subscriptionBillingGrace?.revenue)}</div>
      </div>
    )
  },
}

export const subscriptionRenewedColumn = {
  id: 'af_ars_subscription_renewed',
  header: '订阅续费',
  accessorFn: (row) => row.af_ars_subscription_renewed,
  cell: (row) => {
    const subscriptionRenewed = row.getValue()
    return (
      <div className="flex flex-col text-right">
        <div>{subscriptionRenewed?.userCount}</div>
        <div className="text-xs text-muted-foreground">{formatUSD(subscriptionRenewed?.revenue)}</div>
      </div>
    )
  },
}

export const subscriptionXgradedColumn = {
  id: 'af_ars_subscription_xgraded',
  header: '订阅已变更',
  accessorFn: (row) => row.af_ars_subscription_xgraded,
  cell: (row) => {
    const subscriptionXgraded = row.getValue()
    return (
      <div className="flex flex-col text-right">
        <div>{subscriptionXgraded?.userCount}</div>
        <div className="text-xs text-muted-foreground">{formatUSD(subscriptionXgraded?.revenue)}</div>
      </div>
    )
  },
}

export const subscriptionExistingSubscriberColumn = {
  id: 'af_ars_existing_subscriber',
  header: '现有订阅用户',
  accessorFn: (row) => row.af_ars_existing_subscriber,
  cell: (row) => {
    const subscriptionExistingSubscriber = row.getValue()
    return (
      <div className="flex flex-col text-right">
        <div>{subscriptionExistingSubscriber?.userCount}</div>
        <div className="text-xs text-muted-foreground">{formatUSD(subscriptionExistingSubscriber?.revenue)}</div>
      </div>
    )
  },
}